import React from 'react';
import { Redirect } from 'react-router-dom';

import Saas from '../pages/Saas/index';
import Register from '../pages/Register/views/index';
import AboutUs from '../pages/AboutUs/index';
import Services from '../pages/Services/index';
import TermsOfUse from '../pages/TermsOfUse/index';
import Login from '../pages/Login/index';
import PrivacyPolicy from '../pages/PrivacyPolicy/index';
import ContactUs from '../pages/ContactUs/index';
// import Price from '../pages/Price';

const routes = [
  { path: '/', component: Saas, isTopbarDark: true },
  { path: '/terms-of-use', component: TermsOfUse, isTopbarDark: true },

  { path: '/register', component: Register, isTopbarDark: true },
  { path: '/contact', component: ContactUs, isTopbarDark: true },
  { path: '/about', component: AboutUs, isTopbarDark: true },
  { path: '/services', component: Services, isTopbarDark: true },
  // { path: '/price', component: Price, isTopbarDark: true },
  { path: '/login', component: Login, isTopbarDark: true },
  { path: '/privacy-policy', component: PrivacyPolicy, isTopbarDark: true },
  /* { path: "/blog", component: Blog, isTopbarDark: true }, */
  //{ path: "/team", component: Team, isTopbarDark: true },
  /*{ path: '/changelog', component: Changelog, isTopbarDark: true },*/
  /* { path: '/components', component: ProductComponents, isTopbarDark: true },*/
];

export default routes;
